import type { MeterUploadRow, MeterUploadRowStatusValue } from "./buildTrialRunRow";

export type LedgerRowResult = {
  id: string;
  status: MeterUploadRowStatusValue;
  failureReasonCode?: string;
  failureReasonDetail?: string;
  declarationId?: string | null;
};

export const applyLedgerResult = (
  rows: MeterUploadRow[],
  results: LedgerRowResult[],
): MeterUploadRow[] =>
  rows.map(row => {
    const match = results.find(r => r.id === row.id);
    if (!match) {
      return row;
    }
    return {
      ...row,
      status: match.status,
      failureReasonCode: match.failureReasonCode,
      failureReasonDetail: match.failureReasonDetail,
      // Prefer the freshly-ledgered declaration id; fall back to any existing one
      // so a re-applied result never clears a reference the row already had.
      declarationId: match.declarationId ?? row.declarationId,
    };
  });
